import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import Link from 'components/link';
import { isPresent } from '@seedlang/utils';
import { storePageViewAsNavigationItem } from 'utils/page_view_as_storage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection};
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  flex-wrap: wrap;
`;

const ExternalLink = styled.a`
`;

const LinkWrapper = styled.div`
  display: ${props => props.display};
  margin-left: 15px;
  font-size: 17px;
  align-items: center;
  justify-content: center;
  color: ${props => props.color};
  border-bottom: 2px solid transparent;
  border-bottom-color: ${props => props.isSelected ? props.borderBottomColor : 'transparent'};
  &:hover {
    border-bottom-color: ${props => `${props.borderBottomColor}a1`};
  }
  a {
    color: ${props => props.color};
  }
`;

@observer
class NavigationItemLinks extends React.Component {

  @computed get filteredNavigationItems() {
    if (!this.props.navigationItems) { return null; }
    return this.props.navigationItems.filter(item => (this.props.footer && item.showInFooter) || (this.props.header && item.showInHeader));
  }

  matchRouteDynamic(item) {
    if (item.id === AppUI.clickedLinkId) {
      return true;
    } else if (isPresent(item.routeName)) {
      const routeSplit = item.routeName.replace('.', '/').split('/').filter(Boolean);
      return AppUI.routeStore.routeName && isPresent(AppUI.routeStore.routeName.match(routeSplit[0]));
    } else if (isPresent(item.path)) {
      return window.location.href.match(item.path);
    }
    return false;
  }

  routeCombine(navItem) {
    let route = { name: navItem.routeName };

    if (navItem.routeParams) {
      route = { name: navItem.routeName, params: JSON.parse(navItem.routeParams)};
    }

    return route;
  }
  onClickLink = (item) => {
    AppUI.set('clickedLinkId', item.id);
    storePageViewAsNavigationItem(item.id);
  }

  render() {
    return (
      <Wrapper
        flexDirection={this.props.flexDirection}
        alignItems={this.props.alignItems}
        justifyContent={this.props.justifyContent}
      >
        {
          this.filteredNavigationItems && this.filteredNavigationItems.map(item => {
            if (!item.path && !item.routeName) {
              return null;
            }
            return (
              <LinkWrapper
                display='inline-flex'
                borderBottomColor={this.props.hideBorder ? 'transparent' : '#b7b7b7'}
                isSelected={this.matchRouteDynamic(item)}
                color={this.props.color}
                key={item.id}
                onClick={() =>this.onClickLink(item)}
              >
                {
                  !item.externalLink &&
                    <Link
                      to={item.routeName ? this.routeCombine(item) : item.path}
                      onClick={this.props.afterClick}
                      key={item.id}
                      aria-current={this.matchRouteDynamic(item) ? 'page' : undefined}
                      aria-label={this.matchRouteDynamic(item) ? `${item.name} (current page)` : item.name}
                    >
                      {item.name}
                    </Link>
                }
                {
                  item.externalLink &&
                    <ExternalLink
                      href={item.path}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {item.name}
                    </ExternalLink>
                }
              </LinkWrapper>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(NavigationItemLinks);
